module.exports = __webpack_public_path__ + "static/media/CaseIcon.efe416b8.svg";